<kendo-grid
  [data]="gridView$ | async"
  [height]="'auto'"
  (cellClick)="onCellClick($event)"
  [sortable]="sortSettings"
  [sort]="sort"
  (sortChange)="onSortChange($event)"
  class="pointer"
  >
  <ng-template kendoGridToolbarTemplate>
    <input
      [placeholder]="'tasks_search_input' | i18n"
      kendoTextBox
      (input)="onFilter($event.target.value)"
      style="width: auto"
    />
  </ng-template>
  <kendo-grid-column media="(max-width: 450px)" title="Items">
      <ng-template kendoGridCellTemplate let-dataItem>
          <!-- template for mobile -->
          <h4>{{ dataItem.stepTitle }}</h4>
          <dl>
              <dt>{{ 'task.grid.dueDate' | i18n }}</dt>
              <dd>{{ dataItem.dueDate | i18nDate: { date: "medium" } }}</dd>

              <dt>{{'task.grid.circulation' | i18n }}</dt>
              <dd>{{ dataItem.circulationTitle }}</dd>
          </dl>
      </ng-template>
  </kendo-grid-column>

  <!-- columns for mid-size devices 450px-->
  <kendo-grid-column
    media="(min-width: 450px)"
    field="stepTitle"
    [title]="'task.grid.title' | i18n">
  </kendo-grid-column>
  <kendo-grid-column
    media="(min-width: 680px)"
    field="stepComment"
    [title]="'task.grid.step.comment' | i18n"
    >
  </kendo-grid-column>
  <kendo-grid-column
    media="(min-width: 450px)"
    field="dueDate"
    [title]="'task.grid.dueDate' | i18n"
    >
    <ng-template kendoGridCellTemplate let-dataItem>
      <span class="nobr">{{ dataItem.dueDate | i18nDate: { date: "medium" } }}</span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column
      media="(min-width: 450px)"
      field="circulationTitle"
      [title]="'task.grid.circulation' | i18n">
  </kendo-grid-column>

  <!-- additional columns on large devices 680px-->
  <kendo-grid-column
      media="(min-width: 680px)"
      field="circulationStatus"
      [title]="'task.grid.circulation_status' | i18n">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="nobr">{{ dataItem.circulationStatus | i18nCircStatus }}</span>
      </ng-template>
  </kendo-grid-column>
  <kendo-grid-messages [noRecords]="'kendo_noRecords' | i18n">
  </kendo-grid-messages>
</kendo-grid>
